import React from 'react';
import '../../css/bg.css'

function background() {

    return (
        <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="wave w-full h-64 absolute animate-wave bg-blue-300 opacity-50"></div>
          <div className="wave w-full h-64 absolute animate-wave-slow bg-green-300 opacity-60"></div>
          <div className="wave w-full h-64 absolute animate-wave-slower bg-teal-300 opacity-70"></div>
        </div>
      </div>
    );
}

export default background;
